export default __webpack_public_path__ + "static/media/Screenshot_B18.bf7405c9.jpg";